<tt-page *ngIf="!!edit">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <ng-container *ngTemplateOutlet="info"></ng-container>
        </tt-card>

        <tt-list [ttData]="itemsListContents" [ttBadge]="'badgeinfo'"></tt-list>
    </div>

    <div class="col-xs-12 sp-0" *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <div class="col-xs-12 col-md-4 p-5">
            <tt-page-heading ttModel="h_info" ttTranslate></tt-page-heading>

            <tt-card>
                <ng-container *ngTemplateOutlet="info"></ng-container>
            </tt-card>
        </div>

        <div class="col-xs-12 col-md-4 p-5" *ngIf="itemsListContents.length > 0">
            <tt-page-heading ttModel="h_shipment_contents" ttTranslate></tt-page-heading>
            <tt-list [ttData]="itemsListContents" [ttBadge]="'badgeinfo'"></tt-list>
        </div>
    </div>
</tt-page>

<ng-template #info>
    <ng-container *ngIf="!!edit">
        <tt-input ttLabel="shipmentcontainer_keyno" [ttModel]="edit.shipmentcontainer_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="shipmentcontainer_name" [ttModel]="edit.shipmentcontainer_name" ttReadonly></tt-input>
        <tt-input ttLabel="shipmentcontainerstatus_name" [ttModel]="edit.shipmentcontainerstatus_name" ttReadonly></tt-input>
        <tt-select [ttRememberId]="'w_shipmentcontainer.stocklocation_keyno.stockplaceid=' + edit.stockplace_id_to" ttLabel="stocklocation" [(ttModel)]="edit.stocklocation_keyno" [ttData]="selectListStockLocations" ttDataId="stocklocation_keyno" ttDataName="stocklocation_name"></tt-select>
        <tt-button-save *ngIf="edit.show_shipmentcontainer_receive === '1'" ttText="shipmentcontainer_receive" (ttClick)="receiveChanges()" [ttLoading]="receiving"></tt-button-save>
    </ng-container>
</ng-template>
